import { Trans, withI18n } from '@lingui/react'

import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import { i18nType } from 'views/utils/propTypes'

const ProductVariantsOutOfTradeMessage = ({ i18n }) => (
  <div className="o-ProductVariants__out-message a-box a-box--bordered a-box--blue-light l-flex l-flex--start">
    <div title={i18n._('productVariants.label.noLongerInSortiment')}>
      <IconCircleInfo size="small" />
    </div>
    <div className="u-font-weight--bold u-margin--left o-ProductVariants__out-message-text">
      <Trans id="productVariants.label.noLongerInSortiment" />
    </div>
  </div>
)

ProductVariantsOutOfTradeMessage.propTypes = {
  i18n: i18nType.isRequired,
}

export default withI18n()(ProductVariantsOutOfTradeMessage)
